<section class="sheet-block">
  <h3 class="sheet-block-title">Descrizione</h3>
  <dl class="sheet-facts">
    @if (analyticalData?.objectIndications) {
      <div>
        <dt>Indicazioni sull'oggetto</dt>
        <dd>{{ analyticalData.objectIndications }}</dd>
      </div>
    }
    @if (analyticalData?.subjectIndication) {
      <div>
        <dt>Indicazioni sul soggetto</dt>
        <dd>
          @for (
            item of analyticalData.subjectIndication;
            track item;
            let i = $index
          ) {
            {{ item.subjectIndication }}@if (i + 1 < analyticalData.subjectIndication.length) {; }
          }
        </dd>
      </div>
    }
  </dl>
</section>

@for (item of analyticalData?.subscriptions; track item; let i = $index) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Iscrizione {{ i + 1 }}</h3>
    <dl class="sheet-facts">
      @if (item?.membershipClass?.definition) {
        <div>
          <dt>Classe di appartenenza</dt>
          <dd>{{ item.membershipClass.definition }}</dd>
        </div>
      }
      @if (item?.language?.definition) {
        <div>
          <dt>Lingua</dt>
          <dd>{{ item.language.definition }}</dd>
        </div>
      }
      @if (item?.technique) {
        <div>
          <dt>Tecnica</dt>
          <dd>{{ item.technique.definition }}</dd>
        </div>
      }
      @if (item?.charactersType?.definition) {
        <div>
          <dt>Tipo di caratteri</dt>
          <dd>{{ item.charactersType.definition }}</dd>
        </div>
      }
      @if (item?.author) {
        <div>
          <dt>Autore</dt>
          <dd>{{ item.author }}</dd>
        </div>
      }
      @if (item?.location) {
        <div>
          <dt>Posizione</dt>
          <dd>{{ item.location }}</dd>
        </div>
      }
      @if (item?.transcription) {
        <div>
          <dt>Trascrizione</dt>
          <dd>{{ item.transcription }}</dd>
        </div>
      }
    </dl>
  </section>
}

@for (item of analyticalData?.emblems; track item; let i = $index) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Emblema {{ i + 1 }}</h3>
    <dl class="sheet-facts">
      @if (item?.membershipClass?.definition) {
        <div>
          <dt>Classe di appartenenza</dt>
          <dd>{{ item.membershipClass.definition }}</dd>
        </div>
      }
      @if (item?.qualification?.definition) {
        <div>
          <dt>Qualificazione</dt>
          <dd>{{ item.qualification.definition }}</dd>
        </div>
      }
      @if (item?.identification) {
        <div>
          <dt>Identificazione</dt>
          <dd>{{ item.identification }}</dd>
        </div>
      }
      @if (item?.quantity) {
        <div>
          <dt>Quantità</dt>
          <dd>{{ item.quantity }}</dd>
        </div>
      }
      @if (item?.location) {
        <div>
          <dt>Posizione</dt>
          <dd>{{ item.location }}</dd>
        </div>
      }
      @if (item?.description) {
        <div>
          <dt>Descrizione</dt>
          <dd>{{ item.description }}</dd>
        </div>
      }
    </dl>
  </section>
}

@if (analyticalData?.historycalNews) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Notizie storico-critiche</h3>
    <p class="sheet-prose">{{ analyticalData.historycalNews }}</p>
  </section>
}
